import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/aquila_guzzi.svg'
import _imports_1 from '@/assets/img/delete.png'


const _withScopeId = n => (_pushScopeId("data-v-5f985dc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal full bg_grey withSearch" }
const _hoisted_2 = { class: "modal_header" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sideContainer" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo eagle"
}, null, -1))
const _hoisted_6 = { class: "sideContainer text-end" }
const _hoisted_7 = { class: "modal_body" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: _imports_1,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
            class: "w-50"
          })
        ])
      ]),
      (_ctx.showSearch)
        ? (_openBlock(), _createBlock(_component_form_field, {
            key: 0,
            class: "little mb-2",
            type: "text",
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
            placeholderKey: "app_Cerca",
            placeholderValue: "Cerca"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["selection_div", {selected : item.identifier == _ctx.identifierSelected}]),
          key: item.identifier + item.text + index,
          onClick: ($event: any) => (_ctx.select(item.identifier))
        }, [
          _createVNode(_component_localized_text, {
            class: "white",
            localizedKey: 'app_' + item.text,
            text: item.text
          }, null, 8, ["localizedKey", "text"])
        ], 10, _hoisted_8))
      }), 128))
    ])
  ]))
}